/**
 * Authentication hook - provides convenient access to auth store
 */

import { useAuthStore } from '@/store/authStore';

export const useAuth = () => {
  const {
    user,
    token,
    isLoading,
    error,
    login,
    logout,
    loadUser,
    setError,
    clearError,
    isAuthenticated,
  } = useAuthStore();

  return {
    // State
    user,
    token,
    isLoading,
    error,
    isAuthenticated: isAuthenticated(),

    // Actions
    login,
    logout,
    loadUser,
    setError,
    clearError,

    // Helper methods
    hasRole: (role: string) => {
      return user?.role === role;
    },

    // The manuscript tier, NOT the ilm dashboard `role` column (decision
    // 2026-08-18). Mirrors `require_admin` in the backend's app/utils/auth.py —
    // if these two disagree the UI offers buttons the API then refuses, so they
    // ship together.
    isAdmin: () => {
      return user?.manuscript_role === 'admin';
    },

    isReviewer: () => {
      return user?.role === 'REVIEWER' || user?.role === 'ADMIN';
    },

    isViewer: () => {
      return user?.role === 'VIEWER' || user?.role === 'REVIEWER' || user?.role === 'ADMIN';
    },

    hasPageAccess: (slug: string) => {
      if (!user) return false;
      if (user.manuscript_role === 'admin') return true;
      if (!user.allowed_pages) return true; // null = all pages
      return user.allowed_pages.includes(slug);
    },
  };
};

export default useAuth;
